import { __assign } from 'tslib';
import React__default from 'react';
import { isEmpty } from 'lodash';
import { LocationLiteProvider } from '@invitae/nucleobase-engine-contentful';

var LocationProvider = function (_a) {
    var locationConfig = _a.locationConfig, children = _a.children;
    if (!locationConfig || isEmpty(locationConfig))
        return React__default.createElement(React__default.Fragment, null, children);
    return React__default.createElement(LocationLiteProvider, __assign({}, locationConfig), children);
};

export { LocationProvider as default };
//# sourceMappingURL=LocationProvider.esm.js.map
